import { Injectable } from '@angular/core';
import { Response } from '@angular/http';
import { tokenNotExpired } from 'angular2-jwt';
import { Observable } from "rxjs/Observable";
import 'rxjs/add/operator/do';

import { MainConfig } from '../main-config';
import { HttpService } from './http.service';

@Injectable()
export class AuthService {
  isLoggedIn: boolean = false;

  constructor(
    private mainConfig: MainConfig,
    private http: HttpService
  ) {
    this.isLoggedIn = tokenNotExpired();
  }

  login(email: string, password: string) {
    return this.http
      .post('/auth/sign-in', { email: email, password: password })
      .do(response => {
        let res = response.json();

        if (res.data) {
          localStorage.setItem(this.mainConfig.authTokenName, res.data);
          this.isLoggedIn = true;
        }
      })
      .catch(response => {
        return Observable.throw(response.json() || 'Server error');
      })
    ;
  }

  logout() {
    localStorage.removeItem(this.mainConfig.authTokenName);
    this.isLoggedIn = false;
  }

  changePassword(password) {
    return this.http.post('/auth/change-password', { password: password });
  }

  getUserData() {
    return this.http.get('/auth/get-token-info').map(this.http.getJsonData);
  }
}



// WEBPACK FOOTER //
// ./libs/atenea-cms/src/core/services/auth.service.ts